import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import cx from 'classnames';

import Market from './market';
import PlayersMarket from '../../mobile/components/markets/players-market';
import { LLTextSlider, WithDropdown } from '../../../../components';
import { trans, caseInsensitiveRegExp } from '../../../../common/utils';
import { DeleteFavoriteItemModal } from '../my-favorites/delete-fav-tournament-modal';

const SpecifierBasedMarkets = observer(
    ({
        item,
        match,
        userCanCashout,
        viewSize,
        isOldView,
        setOldView,
        oddAppearance,
        favorites,
        isMarketsTabView,
        user,
        withoutSpecifierBasedHeader,
        isFavorite,
        modal,
        generateMarketName,
        j,
    }) => {
        const [opened, setOpened] = useState(!(item.viewOrder > 10));

        const isMultipleSpecifierMarket = !withoutSpecifierBasedHeader && item.market.specifierBasedMarkets?.length > 1;

        const marketsMarkUp = item.market.specifierBasedMarkets.map((market, i) => {
            return (
                <Market
                    key={j * 100 + i}
                    {...{
                        match,
                        market,
                        userCanCashout,
                        viewSize,
                        isOldView,
                        setOldView,
                        oddAppearance,
                        viewOrder: item.viewOrder,
                        withHeader: !isMarketsTabView,
                        userIsLogged: user.isLogged,
                        favorites,
                        favLoading: favorites.marketsLoading,
                        openedByDefault: isMultipleSpecifierMarket ? i === 0 : undefined,
                        isMultipleSpecifierMarket,
                        withFavorite: !isMarketsTabView && !isMultipleSpecifierMarket,
                        isFavorite,
                        modal,
                        generateMarketName,
                    }}
                />
            );
        });

        return (
            <>
                {isMultipleSpecifierMarket ? (
                    <div className="match-details__market match-details__multiple-market">
                        <div
                            className="match-details__market-header match-details__multiple-market-header"
                            onClick={() => {
                                setOpened((v) => !v);
                            }}
                        >
                            {user.isLogged ? (
                                <span className="match-details__market-header-clickers">
                                    <span
                                        className="match-details__market-header-fav-icon-wrp"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!favorites.marketsLoading) {
                                                if (isFavorite && favorites.isMarketFavorite({ id: item.market.id })) {
                                                    modal.setModal({
                                                        active: true,
                                                        maskBackground: true,
                                                        showHeader: true,
                                                        title: trans('Favorite markets'),
                                                        showCloseButton: true,
                                                        currentKey: 'custom-content',
                                                        customClasses: 'delete-favorite-modal',
                                                        customContent: (
                                                            <DeleteFavoriteItemModal
                                                                deleteItem={(e) => {
                                                                    e.preventDefault();
                                                                    favorites.setFavoriteMarket({
                                                                        id: item.market.id,
                                                                        isFavorite: true,
                                                                    });
                                                                    modal.close();
                                                                }}
                                                                type="market"
                                                            />
                                                        ),
                                                    });
                                                } else {
                                                    favorites.setFavoriteMarket({
                                                        id: item.market.id,
                                                    });
                                                }
                                            }
                                        }}
                                    >
                                        <i
                                            className={`match-details__market-header-fav-icon doruk-star-${
                                                favorites.isMarketFavorite({ id: +item.market.id }) ? 'fill' : 'line'
                                            }`}
                                        ></i>
                                    </span>
                                </span>
                            ) : (
                                <span></span>
                            )}
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: generateMarketName(
                                        item.market.shortName || item.market.shortedName || item.market.name
                                    ),
                                }}
                            />
                            <span className={cx('match-details__multiple-market-icon', opened && 'expanded')}>
                                <i className={cx(' llg-chevron-right')} />
                            </span>
                        </div>
                        <div className={cx('match-details__multiple-market-content', opened && 'expanded')}>
                            {marketsMarkUp}
                        </div>
                    </div>
                ) : null}
                {!isMultipleSpecifierMarket ? marketsMarkUp : null}
            </>
        );
    }
);

const Markets = ({
    match,
    marketGroup,
    activeMarketGroup,
    userCanCashout,
    oddAppearance,
    viewSize,
    marketsCount = 0,
    isOldView,
    setOldView,
    isMarketsTabView = false,
    isFavorite,
    user = {},
    site,
    favorites,
    withoutSpecifierBasedHeader,
    modal,
    searchMarketValue,
}) => {
    const [activeMarket, setActiveMarket] = useState(null);

    useEffect(() => {
        if (isMarketsTabView) {
            setActiveMarket(marketGroup.marketsList(marketsCount)[0]?.market.id);
        }
    }, [isMarketsTabView, marketGroup]);

    const generateMarketName = (marketName) => {
        if (searchMarketValue?.length) {
            const searchRegex = caseInsensitiveRegExp(searchMarketValue);

            return marketName?.replace(searchRegex, '<span style="text-decoration: underline;">$&</span>');
        }
        return marketName;
    };

    const renderMarket = (item, j = 0) => {
        if (item) {
            if (item.market.specifierBasedMarkets.length) {
                if (item.market.isNewPlayersMarket) {
                    return (
                        <PlayersMarket
                            key={j}
                            items={item.market.specifierBasedMarkets}
                            market={item.market}
                            viewSize={viewSize}
                            userCanCashout={userCanCashout}
                            withHeader={!isMarketsTabView}
                            viewOrder={item.viewOrder}
                            match={match}
                            activeMarketGroup={activeMarketGroup}
                            userIsLogged={user.isLogged}
                            favorites={favorites}
                            favLoading={favorites.marketsLoading}
                            isFavorite={isFavorite}
                            modal={modal}
                        />
                    );
                } else {
                    return (
                        <SpecifierBasedMarkets
                            {...{
                                item,
                                match,
                                userCanCashout,
                                viewSize,
                                isOldView,
                                setOldView,
                                oddAppearance,
                                favorites,
                                isMarketsTabView,
                                user,
                                withoutSpecifierBasedHeader,
                                isFavorite,
                                modal,
                                generateMarketName,
                                j,
                            }}
                            key={j}
                        />
                    );
                }
            } else {
                return (
                    <Market
                        key={j}
                        {...{
                            match,
                            market: item.market,
                            userCanCashout,
                            viewSize,
                            isOldView,
                            setOldView,
                            oddAppearance,
                            viewOrder: item.viewOrder,
                            withHeader: !isMarketsTabView,
                            userIsLogged: user.isLogged,
                            favorites,
                            favLoading: favorites.marketsLoading,
                            withFavorite: true,
                            isFavorite,
                            modal,
                            generateMarketName,
                        }}
                    />
                );
            }
        } else {
            return null;
        }
    };

    const renderTabsMarkets = (marketsArr) => {
        if (marketsArr.length === 1) {
            return (
                <div className={cx('market-tabs__select fake-select', viewSize)}>
                    {marketsArr[0]?.market?.shortName || marketsArr[0]?.market?.shortedName || marketsArr[0]?.market?.name}
                </div>
            );
        }

        if (viewSize === 'mobile') {
            const dropdownSrc = marketsArr.map((item) => ({
                label: item?.market?.shortName || item?.market?.shortedName || item?.market?.name,
                code: item?.market?.id,
            }));

            const renderedMarket = activeMarket ?
                marketsArr.find((item) => item.market.id === activeMarket)?.market : null;

            return (
                <WithDropdown
                    dataSource={{ submenu: dropdownSrc }}
                    openBehavior="click"
                    menuItemIsActive={(item) => item.code === activeMarket}
                    onMenuItemClick={(item) => {
                        site.status.setBackdropShown(false);
                        setActiveMarket(item.code);
                    }}
                    delay={500}
                    placement="bottom-end"
                    customClasses="market-tabs__select"
                    menuClasses="market-tabs__select-dropdown"
                >
                    <span
                        onClick={() => {
                            site.status.setBackDropFullScreen(false);
                            site.status.setBackdropShown(true);
                        }}
                    >
                        {(renderedMarket?.shortName || renderedMarket?.shortedName || renderedMarket?.name) ?? ''}
                    </span>
                </WithDropdown>
            );
        }

        return (
            <LLTextSlider
                id={`market-tabs__slider`}
                viewSize={viewSize}
                customClasses={{
                    slider: 'market-tab__slider',
                    arrow: 'market-tab__slider-arrow',
                }}
                activeItem={activeMarket}
            >
                {marketsArr.map((item) => {
                    return (
                        <div
                            className={cx('market-tab__slider-item', activeMarket === item.market.id && 'active')}
                            onClick={() => {
                                setActiveMarket(item.market.id);
                            }}
                            id={item.market.id}
                            key={item.market.id}
                        >
                            {user.isLogged ? (
                                <span
                                    className="match-details__market-header-fav-icon-wrp"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (!favorites.marketsLoading) {
                                            favorites.setFavoriteMarket({
                                                id: item.market.id,
                                            });
                                        }
                                    }}
                                >
                                    <i
                                        className={`match-details__market-header-fav-icon doruk-star-${
                                            favorites.isMarketFavorite({ id: +item.market.id }) ? 'fill' : 'line'
                                        }`}
                                    ></i>
                                </span>
                            ) : null}
                            <span>{item.market.shortName || item.market.shortedName || item.market.name}</span>
                        </div>
                    );
                })}
            </LLTextSlider>
        );
    };

    if (!marketGroup) {
        return null;
    }

    const renderMarkets = (marketsArr) =>
        marketsArr?.length ? marketsArr.map((item, j) => renderMarket(item, j)) : null;

    const marketList = isFavorite
        ? marketGroup.markets
        : searchMarketValue?.length
        ? marketGroup.marketsListSearchedBy(searchMarketValue)
        : marketGroup.marketsList(marketsCount);

    return isMarketsTabView ? (
            <>
                {renderTabsMarkets(marketList)}
                {renderMarket(marketList.find((item) => item.market.id === activeMarket))}
            </>
        ) : (
            renderMarkets(marketList)
        );
};

export default observer(Markets);
